import { render, staticRenderFns } from "./RelacaoContratacao.vue?vue&type=template&id=85866774"
import script from "./RelacaoContratacao.vue?vue&type=script&lang=js"
export * from "./RelacaoContratacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports